/**
 * Letters from an email address, for the avatar disc.
 *
 * Cut at the `@` FIRST. `ada@example.com` split on the separators before the
 * local part is isolated gives "ada" and "example" — "AE" — which reads as a
 * second person's initials.
 *
 * Nothing is invented: no address, or an address with no local part, gives an
 * empty string, and the disc renders with no letters rather than with a
 * placeholder glyph.
 */
export function initialsFromEmail(email: string | null | undefined): string {
  const local = (email ?? '').split('@')[0]
  const [first = '', second] = local.split(/[._+-]+/).filter(Boolean)
  const letters = second === undefined ? [...first].slice(0, 2).join('') : `${[...first][0]}${[...second][0]}`
  return letters.toUpperCase()
}
